// extracted by mini-css-extract-plugin
export var lg = "_34-4";
export var md = "_34-3";
export var sm = "_34-2";
export var xs = "_34-1";
export var xxs = "_34-0";